<template>
  <div>
    <!--  强制提醒   -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :style="{
        '--popup-header-bg': headerColor.headerBg,
        '--popup-border-color': headerColor.headerBg
      }"
      :visible.sync="messageDialog"
      custom-class="system-message-popup-dialog"
      top="6vh"
      width="600px"
    >
      <template #title>
        <div class="popup-header flx-between">
          <div class="popup-header__left">
            <span :style="{ background: headerColor.color }" class="popup-header__icon">
              <img :src="headerIcon" alt="" class="popup-header__icon-img">
            </span>
            <span :style="{ color: titleColor }" class="popup-header__title">
              {{ currentMessageObj.typeName || '系统消息' }}
            </span>
          </div>
          <div
            :class="['popup-header__close', { 'is-disabled': isDisable }]"
            :style="{ color: titleColor }"
            @click="setClose"
          >
            <span class="iconfont icon-guanbi" />
            <span v-if="countdown > 0" class="popup-header__countdown"> ({{ countdown }}s) </span>
          </div>
        </div>
      </template>

      <div class="popup-body">
        <div class="popup-body__scroll">
          <!--  修改为左右布局：左边文字（标题+摘要），右边图片  -->
          <div class="popup-content">
            <!-- 左侧：标题 + 摘要 -->
            <div class="popup-content__left">
              <!--  标题  -->
              <div class="popup-title">
                {{ currentMessageObj.title || currentMessageObj.zhTitle }}
              </div>
              <!--  摘要 (紧跟标题下)  -->
              <div v-if="currentMessageObj.abstract" class="popup-content__text">
                {{ currentMessageObj.abstract || '' }}
              </div>
            </div>

            <!-- 右侧：图片（如果有才显示） -->
            <div v-if="currentMessageObj.textUrl" class="popup-content__image">
              <img :src="currentMessageObj.textUrl" alt="" @click.stop="getImgSrc">
            </div>
          </div>

          <!--  正文 (放在左右布局下方)  -->
          <div
            class="popup-content__text"
            style="color: black; font-size: 14px; margin-top: 12px"
            v-html="currentMessageObj.text || ''"
          />
        </div>

        <!--  发布时间  -->
        <div class="popup-footer">
          <i class="el-icon-time" />
          <span> {{ $t('trajectory.PublishTime') }}：{{ currentMessageObj.createTime || '' }}</span>
        </div>
      </div>
      <!--  关闭  -->
      <div class="popup-action">
        <el-button
          :disabled="isDisable" size="small" style="margin-bottom: 10px"
          @click="setClose"
        >
          {{ $t('GlobalSetObj.close') }}
          <span v-if="countdown > 0" class="popup-action__countdown">({{ countdown }}s)</span>
        </el-button>
      </div>
    </el-dialog>
    <!-- 图片预览 -->
    <ElImageViewer v-if="showViewer" :on-close="closeViewer" :url-list="imgArr" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { readMessageUser } from '@/api/messageCenter';
import store from '@/store';
import settingIcon from '@/assets/images/setting-icon.png';
import speakerIcon from '@/assets/images/speaker-icon.png';
import emergencyAlarmIcon from '@/assets/images/emergencyAlarm-icon.png';
import notificationIcon from '@/assets/images/notification-icon-blue.png';

export default {
  components: {
    ElImageViewer
  },
  data() {
    return {
      intervalId: null,
      messageDialog: false,
      isDisable: true,
      showViewer: false,
      imgArr: [],
      currentMessageObj: {},
      countdown: 0,
      skipRead: false // 是否跳过已读接口（公告查看场景）
    };
  },
  computed: {
    // 根据消息类型 type 返回对应颜色：1 系统更新、14 运营通知、15 紧急公告
    headerColor() {
      const type = this.currentMessageObj.type;
      let color = '#f2f6fe';
      if (type === 1) {
        color = '#19814d';
      } else if (type === 14) {
        color = '#ff8a00';
      } else if (type === 15) {
        color = '#cc2e22';
      }
      // 背景色取主色的 10% 透明度（图标的圆底）
      const bg = `${color}1a`;
      // header 实色背景 + 边框
      const headerBg = color;
      return { color, bg, headerBg };
    },
    // 标题文字颜色：普通消息在浅色底(#f2f6fe)上用品牌蓝，类型消息在实色底上用白色
    titleColor() {
      const type = this.currentMessageObj.type;
      return type === 1 || type === 14 || type === 15 ? '#ffffff' : '#0e6efd';
    },
    // 根据消息类型 type 返回对应图标
    headerIcon() {
      const type = this.currentMessageObj.type;
      if (type === 1) {
        // 系统更新
        return settingIcon;
      } else if (type === 14) {
        // 运营通知
        return speakerIcon;
      } else if (type === 15) {
        // 紧急公告
        return emergencyAlarmIcon;
      }
      // 其他/默认
      return notificationIcon;
    }
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  },
  methods: {
    // 打开登录弹框
    openDialog(data, options = {}) {
      console.log(data, 'data');
      this.currentMessageObj = data;
      // 是否跳过已读接口（如公告中心查看，无需标记已读）
      this.skipRead = !!options.skipRead;
      this.messageDialog = true;
      // 已读消息 / 跳过已读场景 / 无关闭限制（howToClose 为 0/null/undefined）：不启动倒计时，直接可关闭
      const howToClose = this.currentMessageObj.howToClose;
      if (
        data.isRead === 1 ||
        this.skipRead ||
        howToClose === 0 ||
        howToClose === null ||
        howToClose === undefined
      ) {
        this.isDisable = false;
        this.countdown = 0;
      } else {
        this.startCountdown();
      }
    },
    // 倒计时（根据后端 howToClose 字段：10/20/30/40/60s）
    startCountdown() {
      const seconds = Number(this.currentMessageObj.howToClose) || 0;
      this.countdown = seconds;
      this.isDisable = seconds > 0;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      if (seconds <= 0) {
        this.isDisable = false;
        return;
      }
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          this.isDisable = false;
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }, 1000);
    },
    // 点击关闭, 调用已读
    async setClose() {
      if (this.isDisable) return;
      if (this.currentMessageObj.isRead === 0) {
        const data = {
          receiveId: store.getters.userId,
          clientType: 1,
          messageId: this.currentMessageObj.messageId
        };
        await readMessageUser(data);
        this.messageDialog = false;
        // 全局同步未读消息数量 -1
        const current = store.getters.getmessageNumber;
        if (current > 0) {
          store.commit('user/set_getmessageNumber', current - 1);
        }
        this.$emit('readMessage');
      }
      // 跳过已读（公告查看）或已读消息、无关闭限制（howToClose 为 0/null）：直接关闭，不调用已读接口
      const howToClose = this.currentMessageObj.howToClose;
      if (
        this.skipRead ||
        this.currentMessageObj.isRead === 1 ||
        howToClose === 0 ||
        howToClose === null ||
        howToClose === undefined
      ) {
        this.messageDialog = false;
        return;
      }
    },
    // 查看图片
    getImgSrc(e) {
      if (e.target.nodeName !== 'IMG') {
        return;
      }
      this.imgArr = [e.target.src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.popup-header {
  display: flex;
  align-items: center;
  // 左侧：图标 + 标题 垂直水平居中
  &__left {
    display: flex;
    align-items: center;
    height: 100%;
    min-height: 28px;
  }

  // 关闭按钮样式（颜色由 titleColor 内联控制）
  &__close {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.3s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }

    // 禁用状态
    &.is-disabled {
      cursor: not-allowed;
      opacity: 0.5;
      pointer-events: none; // 禁用点击事件

      &:hover {
        background-color: transparent;
      }
    }
  }

  &__countdown {
    margin-left: 4px;
    font-size: 12px;
    // 继承 titleColor，整体略淡
    color: inherit;
    opacity: 0.85;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin-right: 8px;
    border-radius: 50%;
    font-size: 16px;

    &-img {
      width: 18px;
      height: 18px;
      display: block;
      object-fit: contain;
    }
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    // 颜色由 titleColor 内联控制
    letter-spacing: 0.5px;
  }
}

.popup-body {
  padding: 4px 4px 8px;

  &__scroll {
    max-height: 600px;
    overflow-y: auto;
  }
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2329;
  line-height: 1.6;
  margin-bottom: 12px;
}

.popup-content {
  display: flex;
  align-items: flex-start; /* 顶部对齐 */
  gap: 16px;

  &__left {
    flex: 1;
    min-width: 0; /* 防止文字过多撑破布局 */
  }

  &__text {
    font-size: 13px;
    color: #646a73;
    line-height: 1.8;
    word-break: break-word;
  }

  &__image {
    flex-shrink: 0;
    width: 130px; /* 参照你图片的尺寸，可以改大一点 */
    height: 96px;
    border-radius: 8px;
    overflow: hidden;
    background: #f7f8fa;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }
  }
}

.popup-footer {
  margin-top: 16px;
  display: flex;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
  color: #8f959e;

  i {
    margin-right: 4px;
    font-size: 13px;
  }
}

.popup-action {
  display: flex;
  justify-content: center;
  padding-top: 4px;

  &__btn {
    min-width: 100px;
    border-radius: 16px;
  }

  &__countdown {
    margin-left: 2px;
    font-size: 12px;
  }
}
</style>

<!-- 全局样式：覆盖 el-dialog 外观（必须非 scoped） -->
<style lang="scss">
.system-message-popup-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  // 主色边框（覆盖 element-ui 默认阴影/边框）
  border: 1px solid var(--popup-border-color, #cc2e22) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;

  .el-dialog__header {
    padding: 16px 20px 12px !important;
    // 去掉底部边框，避免与 body 之间出现浅色分隔线
    border-bottom: none !important;
    margin-right: 0 !important;
    background: var(--popup-header-bg, #cc2e22);
    color: #fff;
  }

  .el-dialog__body {
    padding: 16px 20px 8px !important;
  }

  .el-dialog__footer {
    padding: 8px 20px 16px !important;
  }

  .el-dialog__close {
    color: rgba(255, 255, 255, 0.85);
    font-size: 16px;
    top: 14px;
    right: 16px;

    &:hover {
      color: #fff;
    }
  }

  .el-dialog__title {
    line-height: 1 !important;
    font-size: 0 !important; // 隐藏默认 title 文字，使用插槽自定义
  }
}
</style>
